import { useTheme } from '@mui/material/styles';
import { Link, navigate } from 'gatsby';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import MainTitle from '@components/MainTitle';
import ItemDiv from '@components/MenuItem';

import {
  ALLERGY_ID,
  APPOINTMENTS_ID,
  BODY_ID,
  CARRIER_STATUS_ID,
  EMERGENCY_VISIT_ID,
  FAMILY_HISTORY_ID,
  HOSPITALIZATION_ID,
  IMAGING_TESTS_ID,
  IMMUNIZATION_ID,
  INSURANCE_PROGRAMS,
  LAB_RESULTS_ID,
  MEDICAL_CONDITION_ID,
  MEDICATION_ID,
  SURGERY_ID,
  VITAL_SIGN_ID,
} from '@constants/survey-ids';
import { RECORD_NAMES, ADD_RECORD_URLS } from '@constants/urls-and-types';

import { useCuration } from '@hooks/useCuration';

import { HorizontalRule } from '@layouts/AuthLayout';

import { resolveIcon } from '@utils/resolveIcon';

const items = [
  APPOINTMENTS_ID,
  SURGERY_ID,
  EMERGENCY_VISIT_ID,
  HOSPITALIZATION_ID,
  IMAGING_TESTS_ID,
  CARRIER_STATUS_ID,
  BODY_ID,
  MEDICAL_CONDITION_ID,
  VITAL_SIGN_ID,
  MEDICATION_ID,
  ALLERGY_ID,
  IMMUNIZATION_ID,
  LAB_RESULTS_ID,
  FAMILY_HISTORY_ID,
  INSURANCE_PROGRAMS,
] as const;

const messages = defineMessages({
  curateRecords: {
    id: 'addRecordModal.curateRecords',
    defaultMessage: 'Curate Records',
  },
});

export default function AddRecordModalContent({
  onClose,
  user_id,
}: {
  onClose: () => void;
  /**
   * User Id of patient
   */
  user_id: string | null;
}) {
  const { formatMessage } = useIntl();
  const { viewAsPatient } = useCuration();
  const theme = useTheme();

  return (
    <>
      <MainTitle title={formatMessage(messages.curateRecords)} />
      <HorizontalRule />
      {items.map((recordType) => {
        return (
          <Link
            key={`add-${recordType}-option`}
            to={ADD_RECORD_URLS[recordType]}
          >
            <ItemDiv
              onClick={() => {
                if (user_id) {
                  viewAsPatient(user_id);
                  navigate(ADD_RECORD_URLS[recordType]);
                  onClose();
                }
              }}
              text={RECORD_NAMES[recordType]}
              {...resolveIcon(recordType, theme)}
            />
          </Link>
        );
      })}
    </>
  );
}
